// extracted by mini-css-extract-plugin
export default {"overlayLink":"GroupDetailPreview-module__overlayLink--DqreG"};